export default __webpack_public_path__ + "static/media/printer.c9ce2c47.svg";